import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "@rui/Stack";

export const OuterContainer = styled(Stack)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.shades.neutral[100]}`,
  padding: theme.spacing(0.5, 0),
}));

type InnerContainerProps = StackProps & { selected: boolean };

export const InnerContainer = styled(
  ({ selected: _, ...props }: InnerContainerProps) => <Stack {...props} />
)(({ selected, theme }) => ({
  borderRadius: "4px",
  padding: theme.spacing(1.5, 2),
  backgroundColor: selected ? theme.palette.shades.ghost[300] : "#FFF",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: theme.palette.shades.ghost[500],
  },
}));
